module.exports = __webpack_public_path__ + "img/sun_over_ice.06f33316.jpg";